// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createHandoffHandoff = (client) => ({
    /**
     * `GET /handoff/seller-contact`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId HandoffGetSellerContact
     * @source apps/backend/src/api/handoff/seller-contact/route.ts
     */
    retrieveSellerContact: (query, headers) => client.fetch("/handoff/seller-contact", { method: "GET", query, headers }),
    /**
     * `POST /handoff/tally/ingest`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId HandoffTallyIngest
     * @source apps/backend/src/api/handoff/tally/ingest/route.ts
     */
    updateTallyIngest: (body, query, headers) => client.fetch("/handoff/tally/ingest", { method: "POST", body, query, headers }),
    /**
     * `POST /handoff/vendor-quote-approval`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId HandoffVendorQuoteApproval
     * @source apps/backend/src/api/handoff/vendor-quote-approval/route.ts
     */
    updateVendorQuoteApproval: (body, query, headers) => client.fetch("/handoff/vendor-quote-approval", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=handoff.js.map